
export const types = {
  SET_SHOW_HEADER: 'app/SET_SHOW_HEADER',
};

export const setShowHeader = (showHeader) => {
  return {
    type: types.SET_SHOW_HEADER,
    showHeader,
  };
};
